import { ThumbsUp, Eye } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { FAQQuestion } from "@/types/faq";
import { cn } from "@/lib/utils";

interface FAQAnswerCardProps {
  question: FAQQuestion;
  onClick: () => void;
}

export const FAQAnswerCard = ({ question, onClick }: FAQAnswerCardProps) => {
  return (
    <Card
      className="cursor-pointer transition-all duration-300 hover:shadow-lg group"
      onClick={onClick}
    >
      <CardContent className="p-6">
        <div className="space-y-4">
          <h3 className="text-lg font-semibold text-foreground group-hover:text-primary transition-colors">
            {question.question}
          </h3>

          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <div className="flex items-center gap-1.5">
              <ThumbsUp className="w-4 h-4" />
              <span>{question.votes.toLocaleString("ro-RO")} voturi</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Eye className="w-4 h-4" />
              <span>{question.views.toLocaleString("ro-RO")} vizualizări</span>
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            {question.urgent && (
              <Badge variant="destructive" className="gap-1">
                Urgent
              </Badge>
            )}
            {question.tags.slice(0, 3).map((tag) => (
              <Badge key={tag} variant="secondary">
                {tag}
              </Badge>
            ))}
            {question.tags.length > 3 && (
              <Badge variant="outline">+{question.tags.length - 3}</Badge>
            )}
          </div>

          {question.articleReference && (
            <p className="text-xs text-muted-foreground">
              Referință: {question.articleReference}
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
